import {
  Link,
  makeStyles,
  ListItem,
  List,
  Grid,
  Divider,
  Box,
  Typography,
  LinearProgress,
  AccordionSummary,
  AccordionDetails,
  Accordion,
  Button,
  Popover,
  Dialog,
  DialogContent,
} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useHistory, useLocation } from "react-router";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import HeaderMenu from "../../../../../Components/HeaderMenu";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import Crf from "./Crf";
import Caf from "./Caf";
import Evaluation from "./Evaluation";
import EditIcon from "@material-ui/icons/Edit";
import ShortlistCoaching from "./ShortlistCoaching";
import ChemistrySession from "./ChemistrySession";
import Sessions from "./Sessions";
import AssignmentOverview from "./AssignmentOverview";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import DataClient from "../../../../../Service/general_data_service";
import AssignmentDrawer from "../../../Admin/Employee/Assignment/AssignmentDrawer";
import Feedback from "./Feedback/index";
import Extension from "./Extension";
import Alert from "./Alert";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import ErrorIcon from "@material-ui/icons/Error";
import { styled } from "@material-ui/core/styles";
import DataService from "../../../../../Service";
import { GLOBAL_STEPPER_DATA } from "../../../../../Redux/actions";
import { showSnackbar } from "../../../../../Components/Snackbar/SnackbarActions";
import { programInfo } from "../../../../../Common/constant";
import InternalUseOnly from "./InternalUseOnly";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    "& .MuiLinearProgress-colorPrimary": {
      backgroundColor: "rgb(234 234 234)",
    },
    "& .MuiLinearProgress-barColorPrimary": {
      backgroundColor: "#077F83",
    },
  },
  root: {
    backgroundColor: "#F7F7F7",
    padding: "0px",
  },
  large: {
    width: theme.spacing(13),
    height: theme.spacing(13),
  },
  sidebar: {
    position: "fixed",
    left: 0,
    top: "64px",
    maxHeight: "100vh",
    overflowY: "auto",
    bottom: 0,
  },
  containerSide: {
    justifyContent: "flex-end",
  },
  sidebarItem: {
    backgroundColor: "#F7F7F7",
    height: "100vh",

    "& hr": {
      height: "0px",
    },
  },
  listItem: {
    padding: "16px",
    justifyContent: "space-between",
    paddingRight: "24px",
  },
  listItemText: {
    fontWeight: "bold",
    paddingLeft: "22px",
  },
  listItemSequenceText: {
    paddingLeft: "22px",
  },
}));

function AssignmentDetail(props) {
  const data = [
    {
      duration: "",
      id: 0,
      module_name: "CRF",
      sequence: [],
    },
    {
      duration: "",
      id: 1,
      module_name: "CAF",
      sequence: [],
    },
    {
      duration: "",
      id: 2,
      module_name: "Evaluation",
      sequence: [],
    },
    {
      duration: "",
      id: 3,
      module_name: "Coach shortlist",
      sequence: [],
    },
    {
      duration: "",
      id: 4,
      module_name: "Feedback",
      sequence: [],
    },
    {
      duration: "",
      id: 5,
      module_name: "Internal Use only",
      sequence: [],
    },
  ];

  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [pageUrl, setPageUrl] = useState("overview");
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [pageData, setPageData] = useState({});
  const [pageContentData, setPageContentData] = useState([]);
  const [sessionTitle, setSessionTitle] = useState("");
  const [sessionId, setSessionId] = useState("");
  const [assignmentDrawer, setAssignmentDrawer] = useState("");
  const [fetchExtData, setFetchExtData] = useState({});

  //create new states for drawer
  const [stepperData, setStepperData] = useState(undefined);
  const [headerType, setHeaderType] = useState(undefined);
  const [headerModal, setHeaderModal] = useState("");
  const [fetchApiFlag, setFetchApiFlag] = useState(false);
  const [headerInputValue, setHeaderInputValue] = useState("");
  const [currentObj, setCurrentObj] = useState("");
  const [moduleName, setModuleName] = useState("");

  const [confirmationDialogOpen, setConfirmationDialogOpen] =
    React.useState(false);
  const [maxWidth, setMaxWidth] = React.useState("sm");
  const [refresh, setRefresh] = useState(false);

  const [newAssignmentData, setNewAssignmentData] = useState({});

  const themeColor =
    sessionStorage.getItem("role") == "admin" ? "#3B86FF" : "#981B1E";

  const location = useLocation();

  const globaluserData = useSelector((state) => state.commonReducer);

  //Access Permission
  const unChangeName = useSelector((state) => state.commonReducer)
    ?.accessPermission?.assignmentDetail?.ShortlistCoaching?.unChangeName;

  const permission = useSelector((state) => state.commonReducer);
  const coachName = history?.location?.state?.currentAssignment?.coach_name;
  // const coacheeName = history?.location?.state?.currentAssignment?.coachee_name
  const [coachData, setCoachData] = useState();
  const [employeeID, setEmployeeID] = useState();
  const [coacheeName, setCoacheeName] = useState();
  const [employeeDetail, setEmployeeDetail] = useState();
  const [partnerID, setPartnerID] = useState();

  //
  const [openDialog, setOpenDialog] = useState(false);
  const [submitClickFlag, setSubmitClickFlag] = React.useState(false);
  const [inputValue, setInputValue] = useState("");
  const [dropdownValue, setDropdownValue] = useState("hours");
  const timeDuration = ["hour", "hours", "minute", "minutes"];
  const [manageModal, setManageModal] = useState([]);
  const [programId, setProgramId] = useState();
  const [remainingTime, setRemainingTime] = useState("");
  const [usedCoachingHourData, setUsedCoachingData] = useState(0);
  const [programData, setProgramData] = useState();
  const [sessionStatus, setSessionStatus] = useState(false);
  //

  const getPartnerData = (coachName) => {
    DataService.getDirectData(`/partner_profiles`)
      .then((response) => {
        let listData = response["partner_profiles"];
        const filterData = listData?.filter(
          (data) => data.full_name === coachName
        );
        setPartnerID(filterData[0].id);
      })
      .catch((err) => {});
  };
  const getCoachData = () => {
    if (pageData.organisation_id) {
      const params = {
        organisation_id: pageData.organisation_id,
      };
      DataService.getDirectData(`/employees`, params)
        .then((response) => {
          let listData = response["employees"];
          setCoachData(listData);
        })

        .catch((err) => {});
    }
  };

  useEffect(() => {
    getCoachData();
  }, [pageData]);

  useEffect(() => {
    fetchProgramFlowSetup();
  }, []);
  //
  const fetchProgramFlowSetup = () => {
    DataService.getData(
      { assignment_id: location?.state?.currentAssignment?.id },
      "assignment_program_flow"
    )
      .then((res) => {
        if (res?.success) {
          let mainData = [...res.data, ...res?.new_pgm_data];
          mainData?.map((item) => {
            if (item.sequence) {
              item.sequence.map((dd) => {
                dd.id = Math.floor(Math.random() * (100 - 1 + 1) + 1);
              });
            }
          });
          setProgramData(mainData);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  ///
  useEffect(() => {
    getData();
    getEmployeeID();
  }, [history?.location?.key, refresh, assignmentDrawer, programData]);

  const getData = (params, setToOverview = true) => {
    DataClient.getData(
      "assignment_details/fetch_assignment_modules?assignment_id=" +
        location?.state?.currentAssignment?.id
    )
      .then((res) => {
        setPageData((oldValue) => ({ ...oldValue, ...res.assignment }));
        pageContentData.length = 0;
        setPageContentData(pageContentData.concat(res?.assignment?.data));
        // if (setToOverview) {
        //   setPageUrl("overview");
        // }
      })
      .catch((res) => {});
  };
  useEffect(() => {
    if (sessionStatus) {
      getData("", false);
      setPageUrl("other");
    }
  }, [sessionStatus]);
  const getEmployeeID = (params) => {
    DataClient.getData(
      "assignment_details/fetch_coachee_details?assignment_id=" +
        location?.state?.currentAssignment?.id
    )
      .then((res) => {
        setEmployeeID(res.employee_id);
        let empId = res.employee_id;
        if (empId) {
          const params = {
            employee_id: empId,
            assignment_id: location?.state?.currentAssignment?.id,
          };
          DataService.getDirectData(
            `/coaching_request_forms/employee_detail`,
            params
          )
            .then((response) => {
              let listData = response.employee_detail;
              setCoacheeName(listData?.coachee_name);
              setEmployeeDetail(listData);
              getPartnerData(listData.coach_name);
              // setLoading(false);
            })

            .catch((err) => {});
        }
      })
      .catch((res) => {});
  };
  const totalTime = {};
  pageContentData?.map(
    (content) =>
      (totalTime[content.programme_info_module_id] =
        +content?.duration.split(" ")[0])
  );

  const withoutSequencePageData = pageContentData
    ?.filter((e) => e.sequence.length <= 0)
    .map((e) => e.programme_info_module_id);
  let totalSequenceTime = {};

  pageContentData?.map((e) => {
    if (e.sequence.length) {
      let durationArray = e.sequence.map((e) => {
        let d = 0;
        if (e.duration.split(" ")[1] === "minutes") {
          d = +e.duration.split(" ")[0] / 60;
        } else {
          d = +e.duration.split(" ")[0];
        }
        return d;
      });
      let spentTime = durationArray?.reduce((sum, seq) => sum + seq, 0);
      totalSequenceTime[e.programme_info_module_id] = spentTime;
    } else {
      if (e.duration.split(" ")[1] === "minutes") {
        totalSequenceTime[e.programme_info_module_id] =
          +e.duration.split(" ")[0] / 60;
      } else {
        totalSequenceTime[e.programme_info_module_id] =
          +e.duration.split(" ")[0];
      }
    }
  });

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleClickConfirmationOpen = () => {
    setConfirmationDialogOpen(true);
  };

  const handleConfirmationClose = () => {
    setConfirmationDialogOpen(false);
  };
  const fetchExtension = (id) => {
    DataClient.getData(
      "assignment_details/fetch_extension?assignment_id=" +
        location?.state?.currentAssignment?.id +
        "&extension_id=" +
        id
    ).then((res) => {
      setPageUrl("Extension");
      handleClose();
      setFetchExtData(res);
    });
  };

  const sessionModuleArray = pageData?.data
    ?.map((e) =>
      e.sequence.length > 0
        ? e.sequence.map((e) => e.module_name)
        : e.module_name.trim()
    )
    .filter((e) => e !== "Chemistry session" ?? "Evaluation ");

  useEffect(() => {
    if (data?.length) {
      const selectedIndexId = data.findIndex(
        (item) => item.module_name === pageUrl
      );
      selectedIndexId !== -1 && setSelectedIndex(selectedIndexId);
    }
  }, [pageUrl, data]);

  const handleChangeData = (event) => {
    setInputValue(event.target.value);
  };

  const handleDurationChange = (value) => {
    setDropdownValue(value);
  };

  const handleModal = (moduleId) => {
    setManageModal((prevVal) => [...prevVal, moduleId]);
  };

  //
  const [sessionCreationLoading, setSessionCreateLoading] = useState({
    loading: false,
    id: null,
  });
  const handleInputSubmit = (e, programIdNew) => {
    // e.preventDefault();
    // const usedHour = usedTime.find((e) => programId in e)[programId];
    // const totalHour = totalTime.find((e) => programId in e)[programId];
    // const remainingTime = totalHour-usedHour;

    // setRemainingTime(remainingTime)
    // console.log(usedHour, totalHour, programId);

    // if (inputValue || dropdownValue) {
    // if (usedHour >= totalHour) {
    //   setManageModal([]);
    //   dispatch(
    //     showSnackbar("error", [
    //       "You have exceeded the available session hours!",
    //     ])
    //   );
    // } else {
    programData.map((program) => {
      if (
        programInfo.includes(program?.module_name.toLowerCase()) &&
        program.programme_info_module_id === programIdNew
      ) {
        program.sequence.push({
          isNew: true,
          duration: ``,
          id: Math.floor(Math.random() * (100 - 1 + 1) + 1),
        });
      } else {
        return null;
      }
    });
    setProgramData(programData);
    setManageModal([]);
    handleSubmit(e, programData);
    // setSessionCreateLoading({loading:true,id:programId});
    // }
    // }
    // else {
    //   setSubmitClickFlag(true);
    // }
  };
  //
  // const addSubItemsModal = () => {
  //   return (
  //     <Dialog
  //       open={true}
  //       fullWidth={true}
  //       maxWidth={"xs"}
  //       onClose={() => {
  //         handleModal(undefined);
  //         setProgramId("");
  //       }}
  //       aria-labelledby="form-dialog-title"
  //     >
  //       <DialogTitle id="form-dialog-title">
  //         <h2
  //           style={{
  //             fontSize: "18px",
  //             fontFamily:"Open Sans",
  //             fontWeight: "700",
  //             color:"rgb(99,101,105)"
  //           }}
  //         >
  //           {" "}
  //           Add next stage
  //         </h2>
  //       </DialogTitle>
  //       <DialogContent>
  //         <TextField
  //           error={submitClickFlag && inputValue == "" ? true : false}
  //           helperText={
  //             submitClickFlag && inputValue == ""
  //               ? "Please enter the value.!"
  //               : ""
  //           }
  //           autoFocus
  //           margin="dense"
  //           id="item"
  //           label="Next stage"
  //           type="number"
  //           fullWidth
  //           onChange={handleChangeData}
  //         />
  //         <br />
  //         <br />

  //         <CustomSelect
  //           // error={submitClickFlag && dropdownValue == "" ? true : false}
  //           // helperText={
  //           //   submitClickFlag && dropdownValue == ""
  //           //     ? "Please select the value.!"
  //           //     : ""
  //           // }
  //           id="time_format"
  //           labelText="Stage duration"
  //           style={{display :"none"}}
  //           displayEmpty
  //           variant="outlined"
  //           itemArr={timeDuration}
  //           parentcall={handleDurationChange}
  //         />
  //       </DialogContent>
  //       <DialogActions>
  //         <Button
  //           disableElevation
  //           variant="contained"
  //           style={{textTransform:"none"}}
  //           onClick={() => {
  //             handleModal(undefined);
  //             setProgramId("");
  //           }}
  //         >
  //           Cancel
  //         </Button>
  //         <Button
  //           disableElevation
  //           variant="contained"
  //           color="secondary"
  //           style={{textTransform:"none"}}

  //           onClick={handleInputSubmit}
  //         >
  //           Add
  //         </Button>
  //       </DialogActions>
  //     </Dialog>
  //   );
  // };

  const handleSubmit = (e, programData) => {
    e.preventDefault();
    programData.map((dd) => {
      delete dd?.id;
      dd?.sequence?.map((seqData) => {
        delete seqData?.id;
      });
      delete dd?.time_format;
    });
    let obj = {
      assignment_id: location?.state?.currentAssignment?.id,
      data: programData,
    };

    if (programData.length) {
      DataService.updateData(obj, "", "assignment_pgm_flow_setup")
        .then((res) => {
          if (res?.success) {
            fetchProgramFlowSetup();
            dispatch(showSnackbar("success", ["Session created successfully"]));
          }
        })
        .catch((err) => {
          console.log("error", err);
          dispatch(showSnackbar("error", [["" + err.message]]));
        })
        .finally(() => {
          setSessionCreateLoading({ loading: false, id: null });
        });
    } else {
      DataService.createData(obj, "assignment_pgm_flow_setup")
        .then((res) => {
          if (res?.success) {
            fetchProgramFlowSetup();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  return (
    <Box classes={{ root: classes.wrapper }}>
      <HeaderMenu />
      <Grid container className={classes.containerSide} direction="row">
        <Grid item xs={4} md={3} className={classes.sidebar} justify="center">
          <div className={classes.sidebarItem}>
            <Box
              style={{
                backgroundColor: "#F7F7F7",
                position: "sticky",
                paddingLeft: "35px",
                paddingTop: "22px",
                top: "0px",
                zIndex: "1300",
              }}
              p={2}
            >
              <Grid container direction="row">
                <Grid item xs={12}>
                  <Typography
                    variant="h2"
                    className={classes.organizationTextColor}
                  >
                    <Box textAlign="left">
                      <Grid container>
                        <Grid item xs={5}>
                          Organization
                        </Grid>
                        <Grid item xs={1} style={{ marginRight: "-16px" }}>
                          :
                        </Grid>
                        <Grid item xs={6}>
                          <Link
                            color="secondary"
                            href="javascript:void(0)"
                            onClick={() => {
                              history.push({
                                pathname: `admin/organisation/${pageData.organisation_id}`,
                                state: {
                                  organisation_name: pageData.organisation_name,
                                },
                              });
                            }}
                          >
                            <Box component="span" fontWeight="fontWeightBold">
                              {pageData.organisation_name}
                            </Box>
                          </Link>
                        </Grid>
                      </Grid>
                    </Box>
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="h2"
                    className={classes.organizationTextColor}
                  >
                    <Box mt={1} textAlign="left">
                      <Grid container>
                        <Grid item xs={5}>
                          Program
                        </Grid>
                        <Grid item xs={1} style={{ marginRight: "-16px" }}>
                          :
                        </Grid>
                        <Grid item xs={6}>
                          <Link
                            color="secondary"
                            href="javascript:void(0)"
                            onClick={() => {
                              history.push({
                                pathname: `admin/organisation/${pageData.organisation_id}`,
                                state: {
                                  organisation_name: pageData.organisation_name,
                                },
                              });
                            }}
                          >
                            <Box component="span" fontWeight="fontWeightBold">
                              {pageData?.program_name}
                            </Box>
                          </Link>
                        </Grid>
                      </Grid>
                    </Box>
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="h2"
                    className={classes.organizationTextColor}
                  >
                    <Box mb={2} mt={1} textAlign="left">
                      <Grid container>
                        <Grid item xs={5}>
                          Coach name
                        </Grid>
                        <Grid item xs={1} style={{ marginRight: "-16px" }}>
                          :
                        </Grid>
                        <Grid item xs={6}>
                          <Link
                            color="secondary"
                            href="javascript:void(0)"
                            onClick={() => {
                              globaluserData.role === "admin" &&
                                // sessionStorage.getItem("role") === "admin" &&
                                employeeDetail?.service_type === "external" &&
                                dispatch({
                                  type: GLOBAL_STEPPER_DATA,
                                  payload: { partner_profile: partnerID },
                                });
                              globaluserData.role === "admin" &&
                              // sessionStorage.getItem("role") === "admin" &&
                              employeeDetail.service_type === "external"
                                ? history.push({
                                    pathname: "/admin/partner/onboarding",
                                  })
                                : globaluserData.role === "admin" &&
                                  // : sessionStorage.getItem("role") === "admin" &&
                                  history.push({
                                    pathname: `admin/organisation/${pageData.organisation_id}/employee/${employeeID}/edit`,
                                    state: {
                                      organisation_name:
                                        pageData.organisation_name,
                                      index: 0,
                                    },
                                  });
                            }}
                          >
                            <Box
                              color="secondary"
                              component="span"
                              fontWeight="fontWeightBold"
                            >
                              {employeeDetail?.coach_name
                                ? employeeDetail?.coach_name
                                : "Not assigned"}
                            </Box>
                          </Link>
                        </Grid>
                      </Grid>
                    </Box>
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{ marginTop: "-17px", marginBottom: 10 }}
                >
                  <Typography
                    variant="h2"
                    className={classes.organizationTextColor}
                  >
                    <Box mt={1} textAlign="left">
                      <Grid container>
                        <Grid item xs={5}>
                          Coachee name
                        </Grid>
                        <Grid item xs={1} style={{ marginRight: "-16px" }}>
                          :
                        </Grid>
                        <Grid item xs={6}>
                          {pageData?.name && globaluserData.role === "admin" ? (
                            // sessionStorage.getItem("role") === "admin" ? (
                            <Link
                              color="secondary"
                              href="javascript:void(0)"
                              onClick={() => {
                                history.push({
                                  pathname: `admin/organisation/${pageData.organisation_id}/employee/${employeeID}/edit`,
                                  state: {
                                    organisation_name:
                                      pageData.organisation_name,
                                    index: 0,
                                  },
                                });
                              }}
                            >
                              <Box component="span" fontWeight="fontWeightBold">
                                {coacheeName ? coacheeName : "Not assigned"}
                              </Box>
                            </Link>
                          ) : (
                            <>
                              {globaluserData.role === "employee" ? (
                                // sessionStorage.getItem("role") === "employee" ? (
                                <Box
                                  component="span"
                                  fontWeight="fontWeightBold"
                                >
                                  {coacheeName ? coacheeName : "Not assigned"}
                                </Box>
                              ) : (
                                <Box
                                  color="#263238"
                                  component="span"
                                  fontWeight="fontWeightBold"
                                >
                                  {coacheeName ? coacheeName : "Not assigned"}
                                </Box>
                              )}
                            </>
                          )}
                        </Grid>
                      </Grid>
                    </Box>
                  </Typography>
                </Grid>
                <Grid item xs={12} style={{ textAlign: "left" }}>
                  <Grid container direction="row">
                    <Grid
                      item
                      xs={2}
                      md={1}
                      style={{
                        textAlign: "center",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Box textAlign="left">
                        <ArrowBackIosIcon
                          style={{ fontSize: 16, color: "#4A4A4A" }}
                          onClick={() => {
                            history.goBack();
                            // history.push({
                            //   pathname: "/ManageInfo",
                            // });
                          }}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={8} md={10} style={{ textAlign: "center" }}>
                      <Typography variant="h2" style={{ color: "#4A4A4A" }}>
                        <Box textAlign="left" fontWeight="fontWeightBold">
                          {pageData.name}
                        </Box>
                        {/* </Link> */}
                      </Typography>
                    </Grid>
                    {permission?.accessPermission?.assignmentDetail
                      ?.editAssignment && (
                      <Grid item xs={2} md={1} style={{ textAlign: "center" }}>
                        {/* {pageData?.status != "Cancelled" && ( */}
                        <Box
                          textAlign="center"
                          bgcolor="#EF7000"
                          width={25}
                          height={25}
                          borderRadius={20}
                        >
                          <EditIcon
                            style={{
                              cursor: "pointer",
                              fontSize: 12,
                              color: "#fff",
                              marginTop: 6,
                            }}
                            onClick={() => {
                              window.document
                                .getElementById("root")
                                ?.scrollIntoView(true);
                              setAssignmentDrawer("edit");
                              setNewAssignmentData({});
                            }}
                          />
                        </Box>
                        {/* )} */}
                      </Grid>
                    )}
                  </Grid>
                </Grid>
                <Grid container direction="row">
                  <Grid item xs={2} md={1}></Grid>
                  <Typography variant="h2" color="secondary">
                    <Box>
                      <Link
                        href="javascript:void(0)"
                        onClick={() => setPageUrl("overview")}
                        color="secondary"
                      >
                        Assignment overview
                      </Link>
                    </Box>
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Box mt={1}>
                    <BorderLinearProgress
                      variant="determinate"
                      value={
                        parseInt(pageData?.completion_percentage?.split(" ")[0])
                          ? parseInt(
                              pageData?.completion_percentage?.split(" ")[0]
                            ) < 100
                            ? parseInt(
                                pageData?.completion_percentage?.split(" ")[0]
                              )
                            : 100
                          : 0
                      }
                    />
                  </Box>
                  <Typography variant="h2" color="primary">
                    <Box textAlign="left" mt={1} fontWeight="fontWeightBold">
                      {pageData?.completion_percentage}{" "}
                      <Typography
                        variant="h2"
                        color="primary"
                        component="span"
                        style={{ fontWeight: "normal" }}
                      >
                        completed
                      </Typography>
                    </Box>
                  </Typography>
                </Grid>
              </Grid>
            </Box>
            {data &&
              data
                .filter(
                  //to-do
                  (option) =>
                    permission?.accessPermission?.assignmentDetail?.sidebar.includes(
                      option.module_name
                    )
                )
                .map((option, index) => {
                  return (
                    <>
                      <Typography variant="h2">
                        <List
                          classes={{ root: classes.root }}
                          component="nav"
                          aria-label="main mailbox folders"
                        >
                          {
                            <ListItem
                              button
                              selected={selectedIndex === option.id}
                              className={classes.listItem}
                              onClick={() => {
                                setPageUrl(option.module_name);
                                setSelectedIndex(index);
                                setSessionId(option.id);
                              }}
                            >
                              <Typography
                                variant="subtitle1"
                                className={classes.listItemText}
                              >
                                {index === 2 && !unChangeName
                                  ? "Shortlisted coaches"
                                  : option.module_name}
                              </Typography>
                              {pageData?.warning?.length
                                ? pageData.warning.includes(
                                    option.module_name
                                  ) && (
                                    <ErrorIcon style={{ color: "#ff9800" }} />
                                  )
                                : null}
                            </ListItem>
                          }
                        </List>
                      </Typography>
                      <Divider />
                    </>
                  );
                })}
            {pageContentData.length > 0 &&
              pageContentData
                .filter(
                  (module) =>
                    !permission?.accessPermission?.assignmentDetail?.moduleNotShow.includes(
                      module?.module_name
                    )
                )
                .map((option, index) => {
                  return (
                    <>
                      <List
                        classes={{ root: classes.root }}
                        component="nav"
                        aria-label="main mailbox folders"
                      >
                        {option?.sequence.length > 0 ? (
                          <ListItem
                            button
                            selected={selectedIndex === data.length + 1 + index}
                            className={classes.listItem}
                          >
                            <Box width="100%">
                              <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                alignItems="center"
                              >
                                <Grid item xs={12}>
                                  <Accordion
                                    style={{
                                      backgroundColor: "transparent",
                                      boxShadow: "none",
                                    }}
                                  >
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1a-content"
                                      id="panel1a-header"
                                      style={{
                                        padding: 0,
                                        maxHeight: "28px",
                                        minHeight: "0",
                                      }}
                                    >
                                      <Grid item xs={12} container>
                                        <Grid item xs={10}>
                                          <Typography
                                            variant="subtitle1"
                                            className={classes.listItemText}
                                          >
                                            {option.module_name}
                                          </Typography>
                                        </Grid>
                                        <Grid item xs={2}>
                                          {option?.make_new_pgm_flow_setups !==
                                            undefined &&
                                            (sessionCreationLoading.loading &&
                                            sessionCreationLoading.id ===
                                              option.programme_info_module_id ? (
                                              <Box
                                                style={{
                                                  alignSelf: "flex-end",
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                }}
                                              >
                                                {" "}
                                                <CircularProgress
                                                  size={25}
                                                  color="primary"
                                                />
                                              </Box>
                                            ) : (
                                              <AddCircleIcon
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  handleModal(
                                                    option.programme_info_module_id
                                                  );
                                                  setProgramId(
                                                    option.programme_info_module_id
                                                  );
                                                  setInputValue("");
                                                  setDropdownValue("");
                                                  setSessionCreateLoading({
                                                    loading: true,
                                                    id: option.programme_info_module_id,
                                                  });
                                                  handleInputSubmit(
                                                    e,
                                                    option.programme_info_module_id
                                                  );
                                                }}
                                                style={{
                                                  fontSize: 25,
                                                  paddingTop:
                                                    option.module_name ===
                                                    "Verbal 360 stakeholder interviews"
                                                      ? "16px"
                                                      : "0px",
                                                  paddingLeft: "16px",
                                                  color: "EF7000",
                                                }}
                                              />
                                            ))}
                                        </Grid>
                                      </Grid>
                                    </AccordionSummary>
                                    <AccordionDetails
                                      style={{ padding: "8px 0" }}
                                    >
                                      <Grid
                                        container
                                        direction="row"
                                        alignItems="center"
                                      >
                                        <Grid
                                          item
                                          xs="11"
                                          style={{
                                            paddingLeft: "36px",
                                            marginTop: "20px",
                                          }}
                                        >
                                          <Box>
                                            <LinearProgress
                                              variant="determinate"
                                              value={
                                                parseInt(
                                                  option.completion_percentage
                                                ) < 100
                                                  ? parseInt(
                                                      option.completion_percentage
                                                    )
                                                  : 100
                                              }
                                              color="secondary"
                                            />
                                          </Box>
                                          <Typography
                                            variant="h2"
                                            style={{ color: "#077F83" }}
                                          >
                                            <Box
                                              textAlign="left"
                                              mt={1}
                                              mb={1}
                                              fontWeight="fontWeightBold"
                                            >
                                              {option.completion_percentage +
                                                " completed"}
                                            </Box>
                                          </Typography>
                                        </Grid>
                                        <Grid item xs="12">
                                          <Typography variant="h2">
                                            {option.sequence?.map(
                                              (sequenceOption) => {
                                                return (
                                                  <List
                                                    classes={{
                                                      root: classes.root,
                                                    }}
                                                    style={{
                                                      backgroundColor:
                                                        "transparent",
                                                    }}
                                                    component="nav"
                                                    aria-label="main mailbox folders"
                                                  >
                                                    <ListItem
                                                      className={
                                                        classes.listItem
                                                      }
                                                      button
                                                      onClick={() => {
                                                        setPageUrl("other");
                                                        setModuleName(
                                                          option.module_name
                                                        );
                                                        setSessionTitle(
                                                          sequenceOption.module_name
                                                        );
                                                        setSessionId(
                                                          sequenceOption.id
                                                        );
                                                        setSelectedIndex(
                                                          data.length +
                                                            1 +
                                                            index
                                                        );
                                                        setCurrentObj({
                                                          ...sequenceOption,
                                                          make_new_pgm_flow_setups:
                                                            option?.make_new_pgm_flow_setups !==
                                                            undefined,
                                                        });
                                                        setRemainingTime(
                                                          totalTime[
                                                            option
                                                              .programme_info_module_id
                                                          ] -
                                                            totalSequenceTime[
                                                              option
                                                                .programme_info_module_id
                                                            ]
                                                        );
                                                      }}
                                                    >
                                                      <Typography
                                                        variant="h2"
                                                        className={
                                                          classes.listItemSequenceText
                                                        }
                                                      >
                                                        {
                                                          sequenceOption.module_name
                                                        }
                                                      </Typography>
                                                      {pageData.warning?.indexOf(
                                                        sequenceOption.module_name
                                                      ) != -1 && (
                                                        <ErrorIcon
                                                          style={{
                                                            color: "#ff9800",
                                                          }}
                                                        />
                                                      )}
                                                    </ListItem>
                                                  </List>
                                                );
                                              }
                                            )}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </AccordionDetails>
                                  </Accordion>
                                </Grid>
                              </Grid>
                            </Box>
                          </ListItem>
                        ) : (
                          <ListItem
                            button
                            selected={selectedIndex === data.length + 1 + index}
                            className={classes.listItem}
                            onClick={() => {
                              setPageUrl(
                                ["Evaluation", "Chemistry session"].includes(
                                  option.module_name.trim()
                                )
                                  ? option.module_name.trim()
                                  : "other"
                              );

                              withoutSequencePageData.includes(
                                option.programme_info_module_id
                              ) &&
                                setRemainingTime(
                                  totalTime[option.programme_info_module_id]
                                );
                              setSessionTitle(option?.module_name?.trim());
                              setSelectedIndex(data.length + 1 + index);
                              setSessionId("");
                              setCurrentObj({
                                ...option,
                                make_new_pgm_flow_setups:
                                  option?.make_new_pgm_flow_setups !==
                                  undefined,
                              });
                            }}
                          >
                            <Grid
                              item
                              xs={12}
                              container
                              style={{
                                maxWidth: "97%",
                                justifyContent: "end",
                              }}
                            >
                              <Grid item xs={9}>
                                <Typography
                                  variant="subtitle1"
                                  className={classes.listItemText}
                                >
                                  {option?.module_name}
                                </Typography>
                              </Grid>
                              <Grid item xs={3} style={{ paddingLeft: "12px" }}>
                                {option?.make_new_pgm_flow_setups !==
                                  undefined && (
                                  <AddCircleIcon
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      console.log(
                                        "option.programme_info_module_id",
                                        option.programme_info_module_id
                                      );
                                      setProgramId(
                                        option.programme_info_module_id
                                      );
                                      handleModal(
                                        option.programme_info_module_id
                                      );
                                      setInputValue("");
                                      setDropdownValue("");
                                      handleInputSubmit(
                                        e,
                                        option.programme_info_module_id
                                      );
                                      setSessionCreateLoading({
                                        loading: true,
                                        id: option.programme_info_module_id,
                                      });
                                    }}
                                    style={{
                                      fontSize: 25,
                                      paddingLeft: "16px",
                                      color: "EF7000",
                                    }}
                                  />
                                )}
                              </Grid>
                            </Grid>
                          </ListItem>
                        )}
                      </List>
                      <Divider />
                    </>
                  );
                })}
            {/* {manageModal.includes(programId) && addSubItemsModal()} */}
            {Object.keys(pageData).length > 0 &&
              pageData.extensions.length > 0 &&
              pageData.extensions.map((option, index) => {
                return (
                  <>
                    <List
                      classes={{ root: classes.root }}
                      component="nav"
                      aria-label="main mailbox folders"
                    >
                      {
                        <ListItem
                          button
                          selected={selectedIndex === index}
                          className={classes.listItem}
                          onClick={() => {
                            fetchExtension(option.id);
                          }}
                        >
                          <Typography
                            variant="h2"
                            className={classes.listItemText}
                          >
                            {option.extension_name}
                          </Typography>
                        </ListItem>
                      }
                    </List>
                    <Divider />
                  </>
                );
              })}

            <List
              classes={{ root: classes.root }}
              component="nav"
              aria-label="main mailbox folders"
            >
              {
                <ListItem className={classes.listItem}>
                  <AddCircleIcon
                    onClick={handleClick}
                    style={{
                      // color: "rgb(64, 137, 252)",
                      fontSize: 40,
                      paddingLeft: "16px",
                      color: "EF7000",
                    }}
                  />
                  <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                  >
                    <Box p={2}>
                      <Box mb={1}>
                        <Button
                          size="small"
                          onClick={() => {
                            setPageUrl("Extension");
                            setFetchExtData({});
                            handleClose();
                          }}
                        >
                          <Typography
                            variant="h6"
                            style={{ textTransform: "none" }}
                          >
                            Add an extension
                          </Typography>
                        </Button>
                      </Box>
                      <Box>
                        <Button
                          size="small"
                          onClick={() => {
                            handleClickConfirmationOpen();
                            handleClose();
                          }}
                        >
                          <Typography
                            variant="h6"
                            style={{ textTransform: "none" }}
                          >
                            Add alert
                          </Typography>
                        </Button>
                      </Box>
                    </Box>
                  </Popover>
                </ListItem>
              }
            </List>
          </div>
        </Grid>
        <Grid
          style={{
            justifyContent: "center",
          }}
          item
          xs={8}
          md={9}
        >
          {pageUrl === "overview" && (
            <AssignmentOverview
              {...props}
              employeeDetail={employeeDetail}
              assignmentDetails={pageData}
              getAssignmnetData={getData}
            />
          )}
          {pageUrl === "CRF" && (
            <Crf
              {...props}
              crf_user_id={pageData.crf_user_id}
              coaching_request_form_id={pageData.coaching_request_form_id}
            />
          )}
          {pageUrl === "CAF" && <Caf {...props} />}
          {pageUrl === "Evaluation" && <Evaluation {...props} />}
          {pageUrl === "Feedback" && (
            <Feedback
              pageData={pageData}
              setPageUrl={setPageUrl}
              {...props}
              assignmentId={location?.state?.currentAssignment?.id}
            />
          )}
          {pageUrl === "Internal Use only" && <InternalUseOnly />}
          {pageUrl === "Coach shortlist" && (
            <ShortlistCoaching
              {...props}
              assignmentId={location?.state?.currentAssignment?.id}
              id={sessionId}
              organisationName={pageData.organisation_name}
              setPageUrl={setPageUrl}
            />
          )}
          {pageUrl === "Chemistry session" && (
            <ChemistrySession
              {...props}
              currentObj={currentObj}
              assignmentId={location?.state?.currentAssignment?.id}
              setPageUrl={setPageUrl}
            />
          )}
          {pageUrl === "Extension" && (
            <Extension
              fetchData={fetchExtData}
              {...props}
              assignmentId={location.state.currentAssignment.id}
              setRefresh={setRefresh}
              setAssignmentDrawer={setAssignmentDrawer}
              setNewAssignmentData={setNewAssignmentData}
            />
          )}
          {pageUrl === "other" && (
            <Sessions
              {...props}
              sessionModuleArray={sessionModuleArray}
              setPageUrl={setPageUrl}
              moduleName={moduleName}
              remainingTime={remainingTime}
              setSelectedIndex={setSelectedIndex}
              key={+new Date()}
              id={sessionId}
              getAssignmentModule={getData}
              title={sessionTitle}
              currentObj={currentObj}
              assignmentId={location.state.currentAssignment.id}
              setSessionStatus={setSessionStatus}
              sessionStatus={sessionStatus}
            />
          )}
        </Grid>
      </Grid>

      {assignmentDrawer === "edit" && (
        <AssignmentDrawer
          {...props}
          handleClose={() => {
            if (newAssignmentData?.extension) {
              setPageUrl("Extension");
              fetchExtension(fetchExtData?.data?.id);
            }
            setAssignmentDrawer("");
          }}
          currentSelection={
            newAssignmentData?.extension
              ? { ...pageData, id: newAssignmentData?.assignment_id }
              : pageData
          }
          setStepperData={setStepperData}
          stepperData={stepperData}
          setHeaderModal={setHeaderModal}
          headerModal={headerModal}
          headerType={headerType}
          setHeaderType={setHeaderType}
          setHeaderInputValue={setHeaderInputValue}
          headerInputValue={headerInputValue}
          fetchApiFlag={fetchApiFlag}
          setFetchApiFlag={setFetchApiFlag}
        />
      )}
      <Box>
        <Dialog
          onClose={handleConfirmationClose}
          aria-labelledby="confirmation-dialog-title"
          open={confirmationDialogOpen}
          maxWidth={maxWidth}
        >
          <DialogContent>
            <Alert
              handleConfirmationClose={handleConfirmationClose}
              assignmentId={location?.state?.currentAssignment?.id}
            />
          </DialogContent>
        </Dialog>
      </Box>
    </Box>
  );
}

export default AssignmentDetail;

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 5,
  [`& .MuiLinearProgress-colorPrimary`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .MuiLinearProgress-bar`]: {
    backgroundColor: theme.palette.primary.main,
  },
}));
